import { Grid } from "@chakra-ui/react";

export function Layout({ children }) {
  return (
    <>
      <Grid gridGap={4} maxW="1400px" w="100%" m="auto" p="1rem" mb="2rem">
        {children}
      </Grid>
    </>
  );
}
